import React, { useEffect, useRef } from "react";
import Banner from './Banner';
import MenuCustomer from './MenuCustomer';
import useTranslations from "i18n/useTranslations";

const TopBanner = () => {
  const btnMenuRef = useRef(null);
  return (
    <>
      <section id="pTopcard-banner">
        <div className="bTopcard">
          <div className="bTopBanner">
            <Banner />
          </div>
          <a id="btnMenu" ref={btnMenuRef}><span></span></a>
        </div>
      </section>
      <MenuCustomer btnMenuRef={btnMenuRef}/>
    </>
  );
};

export default TopBanner;
